import { render, staticRenderFns } from "./UserResetPasswordForm.vue?vue&type=template&id=1559986d"
import script from "./UserResetPasswordForm.vue?vue&type=script&lang=js"
export * from "./UserResetPasswordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports